import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Image } from "@/libraries/design/components";

export interface Logo {
    src: string;
    alt: string;
    width?: number;
}

export interface LogosProps {
    logos: Logo[];
}

export const Logos = ({ logos }: LogosProps) => {
    return (
        <ul css={logosContainerStyle}>
            {logos.map((logo, index) => (
                <li key={index}>
                    <Image
                        src={logo.src}
                        alt={logo.alt}
                        style={{
                            ...logoStyles,
                            ...(logo.width
                                ? { width: `${logo.width}px`, height: "auto" }
                                : {})
                        }}
                    />
                </li>
            ))}
        </ul>
    );
};

const logosContainerStyle = css({
    display: "flex",
    flexWrap: "wrap",
    margin: 0,
    padding: 0,
    listStyleType: "none",
    justifyContent: "center",
    rowGap: token("space.600"),
    columnGap: token("space.400"),
    [media.above.sm]: {
        columnGap: token("space.800")
    },
    [media.above.md]: {
        rowGap: token("space.800")
    },
    alignItems: "center"
});

const logoStyles = {
    height: "32px",
    width: "auto",
    maxWidth: "auto",
    filter: "grayscale(100%) brightness(66%)",
    ["-webkit-filter"]: "grayscale(100%) brightness(66%)"
};
